export default __webpack_public_path__ + "static/media/blender.5495df0d.png";